var DocumentApprovalModule = (function () {
    function DocumentApprovalModule() {
    }
    return DocumentApprovalModule;
}());
export { DocumentApprovalModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-approval/document-approval.module.ts.pre-build-optimizer.js